// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__vkpSn","visible":"Message_visible__-U1Te","hidden":"Message_hidden__3drEW","fadeIn":"Message_fadeIn__11ivL","fadeOut":"Message_fadeOut__3wX8y"};